<template>
    <!--弹窗-->
    <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <div v-loading="disabled">
            <div style="height: 250px !important;">
                <div class="download">
                    <el-upload
                        class="upload-demo"
                        drag
                        action="/"
                        :file-list="fileList"
                        :on-change="handleChange"
                        :on-remove="handleRemove"
                        :auto-upload="false"
                        multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            将<b>A-excel</b>文件拖到此处，或<em>点击上传</em>
                        </div>
                        <div
                            class="el-upload__text"
                            style="font-size: 12px;margin-top: 5px;"
                        >
                            只能上传.xls/.xlsx文件
                        </div>
                    </el-upload>
                </div>
            </div>
            <div style="height: 250px !important; margin-top: 15px">
                <div class="download">
                    <el-upload
                        class="upload-demo"
                        drag
                        action="/"
                        :file-list="fileList"
                        :on-change="handleChange1"
                        :on-remove="handleRemove1"
                        :auto-upload="false"
                        multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            将<b>B-excel</b>文件拖到此处，或<em>点击上传</em>
                        </div>
                        <div
                            class="el-upload__text"
                            style="font-size: 12px;margin-top: 5px;"
                        >
                            只能上传.xls/.xlsx文件
                        </div>
                    </el-upload>
                </div>
            </div>
            <el-form :inline="true">
                <el-form-item label="A-备注:" class="query-form-item">
                    <el-input
                        v-model="query.remark_A"
                        placeholder="请输入A-备注"
                        style="width:160px"
                        clearable
                        size="mini" />
                </el-form-item>
                <el-form-item label="A-asin:" class="query-form-item">
                    <el-input
                        v-model="query.asin_A"
                        placeholder="请输入A-asin"
                        style="width:160px"
                        clearable
                        size="mini"
                    />
                </el-form-item>
                <el-form-item label="B-备注:" class="query-form-item">
                    <el-input
                        v-model="query.remark_B"
                        placeholder="请输入B-备注"
                        style="width:160px"
                        clearable
                        size="mini" />
                </el-form-item>
                <el-form-item label="B-asin:" class="query-form-item">
                    <el-input
                        v-model="query.asin_B"
                        placeholder="请输入B-asin"
                        style="width:160px"
                        clearable
                        size="mini"
                    />
                </el-form-item>
            </el-form>
            <el-row style="margin-top:17px; ">
                <el-button
                    style="float:right;margin-left:6px;"
                    size="mini"
                    plain
                    @click="handleClose(false)"
                >取 消
                </el-button
                >
                <el-button
                    style="float:right"
                    size="mini"
                    type="primary"
                    @click="accountForm()"
                    :loading="disabled"
                >确定
                </el-button
                >
            </el-row>
        </div>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import {asin_display_amount_compare_analysis_add, asin_traffic_comparison_add} from '@/api/advAnalys/advAnalys.js'

    export default {
        data() {
            return {
                fileList: [],
                fileList1: [],
                disabled: false,
                filesize: 0,
                filesize1: 0,
                value: '',
                file_data: null,
                file_data1: null,
                query:{
                    remark_A: '',
                    remark_B: '',
                    asin_A: '',
                    asin_B: '',
                }
            }
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            formData: {
                type: Object,
                default: () => {
                }
            },
        },
        methods: {
            //上传Excel文件的处理方法
            handleChange(file, fileList) {
                if (fileList.length > 1) {
                    this.fileList = [fileList[fileList.length - 1]]
                }
                const fileTemp = file.raw
                let extend = fileTemp.name.substring(
                    fileTemp.name.lastIndexOf('.'),
                    fileTemp.name.length
                )
                if (fileTemp) {
                    if (extend == '.xlsx' || extend == '.xls' || extend == '.csv') {
                        this.file_data = fileTemp
                        this.filesize = fileTemp.size
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '附件格式错误，请删除后重新上传!'
                        })
                    }
                } else {
                    this.$message({
                        type: 'warning',
                        message: '请上传附件!'
                    })
                }
            },
            //上传Excel文件的处理方法
            handleChange1(file, fileList) {
                if (fileList.length > 1) {
                    this.fileList1 = [fileList[fileList.length - 1]]
                }
                const fileTemp = file.raw
                let extend = fileTemp.name.substring(
                    fileTemp.name.lastIndexOf('.'),
                    fileTemp.name.length
                )
                if (fileTemp) {
                    if (extend == '.xlsx' || extend == '.xls' || extend == '.csv') {
                        this.file_data1 = fileTemp
                        this.filesize1 = fileTemp.size
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '附件格式错误，请删除后重新上传!'
                        })
                    }
                } else {
                    this.$message({
                        type: 'warning',
                        message: '请上传附件!'
                    })
                }
            },
            //超过上载文件的最大数量限制如何删除文件
            handleRemove() {
                this.fileList = []
                this.file_data = null
            },
            handleRemove1() {
                this.fileList1 = []
                this.file_data1 = null
            },
            accountForm() {
                if (this.file_data == null) {
                    this.$message({
                        type: 'error',
                        message: '请上传符合格式数据文件！'
                    })
                    return
                }
                if (this.file_data1 == null) {
                    this.$message({
                        type: 'error',
                        message: '请上传符合格式数据文件！'
                    })
                    return
                }
                if (this.filesize / 1024 / 1024 > 10) {
                    this.$message({
                        type: 'error',
                        message: '请上传小于10MB 的数据！'
                    })
                    return
                }
                if (this.filesize1 / 1024 / 1024 > 10) {
                    this.$message({
                        type: 'error',
                        message: '请上传小于10MB 的数据！'
                    })
                    return
                }
                if (this.filesize / 1024 / 1024 > 1 || this.filesize1 / 1024 / 1024 > 1) {
                    this.$notify.info({
                        title: '提示',
                        message: '文件过大，数据处理大约需要1~2分钟',
                        duration: 30000
                    })
                }
                var file = new FormData()
                file.append('file_A', this.file_data)
                file.append('file_B', this.file_data1)

                file.append('asin_A', this.query.asin_A)
                file.append('asin_B', this.query.asin_B)
                file.append('remark_A', this.query.remark_A)
                file.append('remark_B', this.query.remark_B)
                this.disabled = true
                api.asin_traffic_comparison_add(file).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: '导入成功',
                            type: 'success'
                        })
                        this.disabled = false
                        this.handleClose(true)
                    } else if (res.code === 17) {
                        this.disabled = false
                        this.$emit('error-dialog', res)
                        this.$emit('close-callback', true)
                    } else {
                        this.disabled = false
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
                    .catch(() => {
                        this.disabled = true
                    })
            },
            // 关闭弹窗
            handleClose(isshow) {
                this.handleRemove()
                this.handleRemove1()
                this.query = {
                    remark_A: '',
                    remark_B: '',
                    asin_A: '',
                    asin_B: '',
                }
                this.$emit('close-callback', isshow)
                this.disabled = false
            }
        }
    }
</script>
<style type="text/scss" lang="scss">
    .download {
        display: flex;
        justify-content: center;
    }

    .top {
        margin: 0px auto;
        width: 60%;
        margin-bottom: 20px;
        display: flex;
    }
</style>
